const errorMessages = {
  'Failed to load data': 'Не удалось загрузить данные',
  'missing launch params': 'Не переданы параметры запуска VK Mini Apps',
  'invalid launch params': 'Некорректные параметры запуска VK Mini Apps',
  'invalid vk signature': 'Некорректная подпись VK Mini Apps',
  'missing vk_user_id': 'Не передан идентификатор пользователя VK',
  'category purchase required': 'Откройте категорию, чтобы начать тренировку'
};

export function localizeErrorMessage(message) {
  if (!message) {
    return 'Не удалось загрузить данные';
  }
  return errorMessages[message] || message;
}

export function ensureArray(value) {
  return Array.isArray(value) ? value : [];
}
